import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TypeValidation } from '@direction/control-validation';
import { ResourceService } from '@direction/translate';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { StudentService } from 'src/app/core/services/student.service';

@Component({
  selector: 'ds-modal-keyboard',
  templateUrl: './modal-keyboard.component.html',
  styleUrls: ['./modal-keyboard.component.scss']
})
export class ModalKeyboardComponent implements OnInit {
  confirmResult!: Subject<boolean>;
  formKeyboard!: FormGroup;
  messageStatus: string;
  imageFingerPrint: string;
  showRenewFingerprint = false;

  @Input() public title: string = '';
  @Input() public nationalId: string = '';

  validators: any;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private studentService: StudentService,
    private resourceService: ResourceService
  ) {}

  ngOnInit(): void {
    this.formKeyboard = this.fb.group({
      keyboardPassword: this.fb.control('', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
      repeatPassword: this.fb.control('', [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
        this.helpersService.equalsTo('keyboardPassword')
      ])
    });
    this.confirmResult = new Subject();

    this.validators = {
      keyboardPassword: [
        {
          type: TypeValidation.Required,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.password.required')
        },
        {
          type: TypeValidation.Minlength,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.password.minLength')
        },
        {
          type: TypeValidation.Maxlength,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.password.maxLength')
        }
      ],
      repeatPassword: [
        {
          type: TypeValidation.Required,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.repeatPassword.required')
        },
        {
          type: TypeValidation.Minlength,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.repeatPassword.minLength')
        },
        {
          type: TypeValidation.Maxlength,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.repeatPassword.maxLength')
        },
        {
          type: TypeValidation.EqualsTo,
          message: this.resourceService.getResource('@direction.pages.student.modalKeyboard.validations.repeatPassword.equalsTo')
        }
      ]
    };
  }

  onConfirm() {
    this.confirmAndClose(this.formKeyboard.value);
  }

  closeModal() {
    this.confirmResult.next(false);
  }

  private confirmAndClose(value: any) {
    this.confirmResult.next(value);
    this.bsModalRef.hide();
  }
}
